import React from "react";
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {observer} from "mobx-react";
import { SideMenuComponentBox } from "./boxes/side-menu-component.box";
import {SideMenuLinksGroup} from "../side-menu-rework/side-menu-links-group/side-menu-links-group.component";
import {GameSearchComponent} from "../game-search/game-search.component";
import {BrandListComponent} from "../brand-list/brand-list.component";
import {StoreButton} from "./store-button/store-button.component";
import {InsideOrbitMenuContainerComponent} from "../inside-orbit-menu-container/inside-orbit-menu-container.component";
import {isInsideAutomation} from '../../../utils/automation-helpers';
import {MenuLinksGroupsContainerBox} from "./boxes/menu-links-goups-container.box";
import {SideMenuContainerBox} from "./boxes/side-menu-container.box";
import {CyClass} from '../../../common/cy-classes';
import {Check} from '@sparkware/app-utils';
import classNames from 'classnames';

@observer
export class SideMenu extends OrbitComponent {

  render() {
    const linkBlocks = this.services.configuration.data.sideMenu.menuLinksBlockOrder;

    return (
      <SideMenuContainerBox className="cy-side-menu">
        {this.services.device.isMobile ? <GameSearchComponent className={CyClass('cy-menu-links-group')}/> : null}

        <MenuLinksGroupsContainerBox>
          {linkBlocks.map(keys => this._renderSideMenuSection(...keys))}

          {this._renderMobileMenuElements()}
        </MenuLinksGroupsContainerBox>
      </SideMenuContainerBox>
    );
  }

  /* Renders the QA button container for mobile only.Can't put it in header on mobile since it overlaps with 888logo on portrait mode */
  private _renderInsideOrbitMenuContainerMobile(): React.ReactNode{
    if(!this.services.device.isMobile) {
      return null;
    }
    if (isInsideAutomation()) {
        return null;
    }
    return <InsideOrbitMenuContainerComponent/>

  }

  private _renderSideMenuSection(...keys: string[]): React.ReactNode {

    if (this.services.device.isMobile && this.services.gameSearch.isSearchBoxOpened) {
      return null;
    }

    return <SideMenuLinksGroup key={keys.join(',')} menuItemIds={keys} />
  }

  private _renderMobileMenuElements(): React.ReactNode {
    if(!this.services.device.isMobile || this.services.gameSearch.isSearchBoxOpened) {
      return null;
    }

    return (
      <div className="cy-menu-links-group mobile-menu-elements">
        {this._renderHelpAndLangSwitcher()}
        {this._renderBrandList()}
        {this._renderInsideOrbitMenuContainerMobile()}
        {this._renderStoreButton()}
      </div>
    );
  }

  private _renderHelpAndLangSwitcher(): React.ReactNode {
    const sideMenuConfiguration = this.services.configuration.data.sideMenu;
    const isLanguageSwitcherEmpty = this.services.language.languageSwitcher.isEmpty;

    if (!sideMenuConfiguration.helpLinkMobile.display && isLanguageSwitcherEmpty)
      return null;

    return (
      <SideMenuComponentBox>
        {sideMenuConfiguration.helpLinkMobile.display ? this._renderMobileHelp() : null}
        {isLanguageSwitcherEmpty ?  null : this._renderMobileLangSwitcher()}
      </SideMenuComponentBox>
    )
  }

  private _renderMobileHelp(): React.ReactNode {
    return (
      <div className="cy-menu-item help-mobile">
        <a className="cy-help-mobile-link help-mobile-link" onClick={() => this.services.sideMenu.openHelp()}>
          {this.services.translation.translate("HELP")}
        </a>
      </div>
    );
  }

  private _renderMobileLangSwitcher(): React.ReactNode {
    return (
      <div className="cy-menu-item lang-switch-mobile" onClick={() => this.services.sideMenu.openMobileLanguageSwitcher()}>
        <a className={classNames("lang-switch-mobile-link", CyClass('cy-lang-switch-label'))}>
          {this.services.translation.translate("LANGUAGES")}
        </a>
        <span className={classNames('selected-lang', CyClass('cy-lang-switch-current-lang'))}>{this.services.language.currentLanguage}</span>
      </div>
    );
  }

  private _renderBrandList(): React.ReactNode {
    const config = this.services.configuration.data.sideMenu.brand_sites;
    if (!config || !config.display)
      return null;

    if(Check.isEmpty(config.sites)) {
      return null;
    }

    return (
      <div className="cy-menu-item brand-switch-mobile">
        <BrandListComponent brands={config.sites}/>
      </div>
    )
  }

  private _renderStoreButton(): React.ReactNode {
    if (!this.services.configuration.data.sideMenu.store_button.display)
      return null;


    return (
      <React.Fragment>
        <div className="hr-border-light-line"></div>
        <StoreButton/>
      </React.Fragment>
    );
  }
}
